import React from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TEMPLATES } from "@/constants/testIds";

const CATEGORIES = [
  "Hospital", "Médicos", "Enfermería", "Administración",
  "Gerencia", "TI", "Laboratorio", "Radiología", "Compras", "General",
];

export function TemplateForm({ template, onChange, isNew, changeNote, onChangeNote }) {
  const set = (patch) => onChange({ ...template, ...patch });
  const categories = !template.category || CATEGORIES.includes(template.category)
    ? CATEGORIES : [template.category, ...CATEGORIES];
  return (
    <Card className="lg:col-span-3 p-5 border-slate-200 shadow-sm">
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <Label className="text-xs font-semibold text-slate-700 uppercase tracking-wider">Nombre</Label>
            <Input value={template.name} onChange={(e) => set({ name: e.target.value })}
              data-testid={TEMPLATES.nameInput} className="focus-visible:ring-orange-500" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-semibold text-slate-700 uppercase tracking-wider">Categoría</Label>
            <Select value={template.category} onValueChange={(v) => set({ category: v })}>
              <SelectTrigger className="focus:ring-orange-500" data-testid={TEMPLATES.categoryInput}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {categories.map((c) => (<SelectItem key={c} value={c}>{c}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs font-semibold text-slate-700 uppercase tracking-wider">Descripción</Label>
          <Input value={template.description} onChange={(e) => set({ description: e.target.value })}
            data-testid={TEMPLATES.descriptionInput} className="focus-visible:ring-orange-500" />
        </div>

        <Tabs defaultValue="html">
          <TabsList className="bg-slate-100">
            <TabsTrigger value="html">HTML</TabsTrigger>
            <TabsTrigger value="css">CSS</TabsTrigger>
          </TabsList>
          <TabsContent value="html" className="mt-3">
            <Textarea value={template.html_content}
              onChange={(e) => set({ html_content: e.target.value })}
              className="font-mono text-xs min-h-[380px] focus-visible:ring-orange-500 border-slate-200"
              data-testid={TEMPLATES.htmlEditor} spellCheck={false} />
            <p className="text-[11px] text-slate-500 mt-2 leading-relaxed">
              <strong>Importante:</strong> Use tablas HTML + CSS inline. Evite flexbox, grid y JavaScript
              para máxima compatibilidad con clientes de correo.
            </p>
          </TabsContent>
          <TabsContent value="css" className="mt-3">
            <Textarea value={template.css_content}
              onChange={(e) => set({ css_content: e.target.value })}
              className="font-mono text-xs min-h-[380px] focus-visible:ring-orange-500 border-slate-200"
              placeholder="/* CSS opcional (los clientes de correo prefieren inline styles) */"
              spellCheck={false} />
          </TabsContent>
        </Tabs>

        {!isNew && (
          <div className="space-y-1.5">
            <Label className="text-xs font-semibold text-slate-700 uppercase tracking-wider">
              Nota del cambio (para el historial de versiones)
            </Label>
            <Input value={changeNote} onChange={(e) => onChangeNote(e.target.value)}
              placeholder="Ej: Ajuste de colores"
              className="focus-visible:ring-orange-500" data-testid="template-change-note" />
          </div>
        )}
      </div>
    </Card>
  );
}
